import { Link } from 'react-router-dom';
import { Trophy } from 'lucide-react';
import { Card } from '../../PrizeDraw/components/ui';

const WALLET_RENT_CREDITS_PATH = '/wallet#rd-rent-savings';

export function SkillTestSuccessState() {
  return (
    <Card className='relative overflow-hidden p-8 text-center shadow-[0_10px_30px_rgba(0,0,0,0.08)]'>
      <div
        className='mx-auto mb-5 flex h-[64px] w-[64px] items-center justify-center rounded-full bg-[#E8F9F1] text-[#0E9F6E]'
        aria-hidden='true'
      >
        <Trophy className='h-8 w-8' />
      </div>

      <p className='mb-2 text-[12px] font-semibold uppercase tracking-[0.14em] text-[#0E9F6E]'>
        You won a rent drop
      </p>

      <h1 className='mb-3 font-display text-[28px] font-semibold leading-tight text-[#0A0B14]'>
        Congratulations! 🎉
      </h1>

      <p className='mx-auto max-w-[400px] text-[15px] leading-6 text-[#5B6478]'>
        You aced the skill-testing question and locked in your{' '}
        <span className='font-semibold text-[#0E9F6E]'>rent credit</span>.
      </p>

      <p className='mx-auto mt-3 max-w-[400px] text-[14px] leading-6 text-[#5B6478]'>
        We&apos;ll apply it to your next rent payment. A confirmation is on its way to your email.
      </p>

      <div className='mt-8 space-y-3'>
        <Link
          to={WALLET_RENT_CREDITS_PATH}
          className='inline-flex w-full max-w-[320px] items-center justify-center rounded-[10px] bg-[#0E9F6E] px-4 py-3 text-[14px] font-semibold text-[#0A0B14] transition hover:bg-[#0B875C]'
        >
          See my rent credit
        </Link>

        <div>
          <Link
            to='/login'
            className='text-[14px] font-medium text-[#5B6478] underline-offset-4 transition hover:text-[#0A0B14] hover:underline'
          >
            Back to home
          </Link>
        </div>
      </div>
    </Card>
  );
}
